import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMUserResource from 'resources/SMUserResource';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import sprintf from 'sprintf';

class SMReputationFormView extends React.Component {
  
  constructor(props) {
    super(props);
    this.hasReputation = false;
    this.state = {
      score: 0,
      description: "",
      errorMessage: "",
      display: SMConst.Display.Visible,
    };
  }
  
  requestResource(props) {
    if (props.reservation.can_be_reviewed) {
      this.setState({
        score: 0,
        description: "",
        errorMessage: "",
      });
      SMOwnerResource.getReputation(props.reservation, (reputation, error)=>{
        if(error) return;
        this.setState({
          score: reputation.score,
          description: reputation.description,
        });
        this.renderStars(reputation.score);
        this.hasReputation = true;
      });
    }
  }
  
  componentDidMount() {
    this.subscribeRateEvent();
    this.requestResource(this.props);
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.reservation !== nextProps.reservation){
      this.requestResource(nextProps);
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.reservation !== prevProps.reservation){
      this.subscribeRateEvent();
    }
  }
  
  renderDefault() {
    return (
      <p className="dashboard-content mb50">{I18n.t("dashboard.text_000021")}</p>
    );
  }
  
  renderEnded() {
    return (
      <p className="dashboard-content mb50">{I18n.t("dashboard.text_000025")}</p>
    );
  }
  
  subscribeRateEvent() {
    let $starContainer = $(this.refs.starContainer),
        $stars = $starContainer.find("i"),
        required = "fa fa-star post-review-star__star fa-2x";
    
    $stars.
      on("mouseenter", (e)=>{
        if (this.state.display == SMConst.Display.Loading) return;
        this.renderStars($(e.currentTarget).data("score"));
      }).
      on("mouseleave", (e)=>{
        if (this.state.display == SMConst.Display.Loading) return;
        this.renderStars(this.state.score);
      }).
      on("click", (e)=>{
        if (this.state.display == SMConst.Display.Loading) return false;
        this.setState({score: $(e.currentTarget).data("score")});
        this.renderStars(this.state.score);
        return false;
      });
  }
  
  renderStars(max) {
    let $starContainer = $(this.refs.starContainer),
        $stars = $starContainer.find("i"),
        required = "fa fa-star post-review-star__star fa-2x";
    $stars.each(function(i){
      let c = required + ((max <= i) ? " is-default" : " is-checked");
      $(this).attr("class", c);
    });
  }
  
  renderDone() {
    let reservation = this.props.reservation;
    return (
      <div>
        <p className="fr">
          <a href={Routes.users_path(reservation.user.username)} className="button-gray pt13 pb13 w180 mr5">{I18n.t("dashboard.label_000111")}</a>
          <a href={Routes.reputations_space_room_path(reservation.room.space.username, reservation.room.uid)} className="button-gray pt13 pb13 w180">{I18n.t("dashboard.label_000112")}</a>
        </p>
        <p className="dashboard-content mb50">{I18n.t("dashboard.text_000020")}</p>
      </div>
    );
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }    
  
  formDidSubmit(e){
    e.preventDefault();
    this.trackPageEvent('od submit reputation');
    
    if (this.state.display == SMConst.Display.Loading) return;
    this.setState({display: SMConst.Display.Loading});
    
    let form = e.currentTarget;
    let formData = new FormData(form);
        
    $(form).startLoading();
    
    if (this.props.isOwner) {
      if (this.hasReputation) {
        SMOwnerResource.updateReputation(this.props.reservation, formData, (reputation, error, xhr)=>{
          $(form).stopLoading();
          this.assignValues(reputation, error, xhr);
        });
      } else {
        SMOwnerResource.postReputation(this.props.reservation, formData, (reputation, error, xhr)=>{
          $(form).stopLoading();
          this.assignValues(reputation, error, xhr);
        });
      }
    } else {
      if (this.hasReputation) {
        SMUserResource.updateReputation(this.props.reservation, formData, (reputation, error, xhr)=>{
          $(form).stopLoading();
          this.assignValues(reputation, error, xhr);
        });
      } else {
        SMUserResource.postReputation(this.props.reservation, formData, (reputation, error, xhr)=>{
          $(form).stopLoading();
          this.assignValues(reputation, error, xhr);
        });
      }
    }
  }
  
  assignValues(reputation, error, xhr){
    let state = this.state,
        $messageContainer = $("#js-split_view-main");
    state.display = SMConst.Display.Visible;
    if (error) {
      $messageContainer.showFailMessage(I18n.t("dashboard.error_000001"));
      state.errorMessage = xhr.responseJSON.message;
    } else {
      $messageContainer.showSuccessMessage(I18n.t("dashboard.notice_000001"));
      state.score = reputation.score;
      state.description = reputation.description;
      this.hasReputation = true;
    }
    this.setState(state);
  }
  
  didChangeValue(e){
    this.setState({
      description: e.currentTarget.value,
    });
  }
  
  renderForm() {
    let errorRow = (this.state.errorMessage) ? <p className="is-error mb10">{this.state.errorMessage}</p> : "";
    let disabled = this.state.display == SMConst.Display.Loading ? true : false;
    return (
      <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
        <div className="post-review">
          <p className="dashboard-content mb15">
            {sprintf(I18n.t("dashboard.text_000018"), this.props.isOwner ? I18n.t("dashboard.label_000102") : I18n.t("dashboard.label_000101"))}<br />
            {I18n.t("dashboard.text_000024")}
            <span className="message-important">{I18n.t("dashboard.text_000019")}</span><br />
          </p>
          <input disabled={disabled} name="score" value={this.state.score} type="hidden"></input>
          <textarea disabled={disabled} onChange={this.didChangeValue.bind(this)} name="description" value={this.state.description} className="form-textarea post-review-form" placeholder={I18n.t("dashboard.text_000022")}></textarea>
          {errorRow}
          <p ref="starContainer" className="post-review-star">
            <a href="#"><i data-score="1" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="2" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="3" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="4" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
            <a href="#"><i data-score="5" className="fa fa-star post-review-star__star fa-2x is-default"></i></a>
          </p>
          <p className="message-supplement post-review-star__comment">{I18n.t("dashboard.label_000105")}</p>
        </div>
        <p className="post-review-buttonarea">
          <SMFormSubmitButton 
            display={this.state.display}
            title={I18n.t("dashboard.label_000106")} 
            options={{className: "button-green maincol-buttonarea__button"}} />
        </p>
      </form>
    );
  }
  
  render() {
    let reservation = this.props.reservation;
    if (reservation.method != SMConst.ReservationMethod.Reservation) {
      return null;
    }
    if (reservation.can_be_reviewed) {
      return this.renderForm();
    }
    else if (SMReservationHelper.isCompletedReservation(reservation) &&
      new Date(reservation.ended_at) < new Date()) {
      return this.renderEnded();
    }
    else {
      return this.renderDefault();
    }
  }
}

SMReputationFormView.propTypes = {
  reservation: PropTypes.object.isRequired,
  isOwner: PropTypes.bool.isRequired,
};
export default SMReputationFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReputationFormView.jsx